/**
 * Created by Daniela on 27/09/2016.
 */
import { Component }   from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { materialTitle, materialCodigoMask, materialGrupoCodigoMask } from "../shared/data.service";
import { Material } from "../shared/material.model";
import { contaContabilCodigoMask } from "../../../../contas/conta-contabil/shared/data.service";
import { MaterialService } from "../shared/material.service";
import { UtilService } from "../../../../shared/services/util.service";

declare var swal: any;

@Component({
  template: require('./material-detail.component.html')
})
export class MaterialDetailComponent {
  materialTitle: any = materialTitle;
  detail: any = new Material();
  showLoad: boolean = false;
  classificacao: string = '';
  tabSelected: string = 'detalhes';
  materialMask: number = materialCodigoMask;
  materialGrupoMask: number = materialGrupoCodigoMask;
  contaContabilMask: number = contaContabilCodigoMask;

  constructor(
    private _materialService: MaterialService,
    private _utilService: UtilService,
    private _route: ActivatedRoute
  ){}

  ngOnInit(){
    var onDone = (function(Response: any) {
      if (!Response.error) {
        if (Response) {
          this.detail = Response;

          this.detail.subgrupo = this.detail.grupoMaterial;
          this.detail.grupo = this.detail.subgrupo.grupo;
          this.classificacao = this._materialService.getClassificacao(this.detail);
        } else {
          this._utilService.swalMessageWarningCustom(Response.error);
        }
      } else {
        this._utilService.swalMessageWarningCustom(Response.error);
      }
      this.showLoad = false;
    }.bind(this));

    this._route.params.forEach((params: Params) => {
      let id = +params['id'];
      this._materialService.onGetById(id, onDone);
    });
  }

  setTab(tab:string) {
    this.tabSelected = tab;
  }

  isTab(tab: string) {
    var isTab: boolean = (tab === this.tabSelected) ? true: false;
    return isTab;
  }

  onclickGoToList() {
    this._materialService.goToList();
  }

  onclickGoToEdit() {
    this._materialService.clearStorage();

    this._materialService.goToEdit(this.detail.id);
  }

  onclickDelete() {
    swal({
        title: "Você deseja realmente excluir este item?",
        text: "O item será desativado.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, Excluir",
        cancelButtonText: "Cancelar",
        closeOnConfirm: false
      },
      function() {
        this.onDelete();
      }.bind(this)
    );
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error) {
        this._utilService.swalMessageDeleteSuccess();
        this.onclickGoToList();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._materialService.onDelete(this.detail.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/material-detail/material-detail.component.ts
 **/